export function getCanvasOffset(e, stage) {
    const rect = stage.getCanvas().getBoundingClientRect();
    return { x: e.pageX - (rect.left + window.scrollX), y: e.pageY - (rect.top + window.scrollY) };
}
export function getCurrentContext(e, stage) {
    const { x: canvasX, y: canvasY } = getCanvasOffset(e, stage);
    const elementsAtCanvasCoordinates = stage.getElementsAtCoordinates(canvasX, canvasY);
    return {
        currentElement: elementsAtCanvasCoordinates.find((v) => { var _a; return (_a = v.element.data) === null || _a === void 0 ? void 0 : _a.capturePointerEvents(); }),
        canvasOffsetX: canvasX,
        canvasOffsetY: canvasY,
    };
}
export function getAncestors(node) {
    const path = [];
    let n = node;
    do {
        path.push(n);
        n = n.parent;
    } while (n !== undefined);
    return path.reverse();
}
export function getCommonAncestor(node1, node2) {
    if (!node1 || !node2) {
        return undefined;
    }
    const pathNode1 = getAncestors(node1);
    const pathNode2 = getAncestors(node2);
    const m = Math.min(pathNode1.length, pathNode2.length);
    let index;
    for (index = 0; index < m; index++) {
        if (pathNode1[index] !== pathNode2[index]) {
            break;
        }
    }
    return index > 0 ? pathNode1[index - 1] : undefined;
}
//# sourceMappingURL=utils.js.map